import { useUpgradeVip } from "@/components/payment/UpgradeVipButton";
import { PaymentDialogCallback } from "@/stores/slices/paymentSlice";

// -30013   非会员，50页内的图片型文献
// -30015   50页以上的图片型文献
export const checkIsExceedMaxPages = (extractStatus: number | undefined) => {
  return [-30013, -30015].includes(extractStatus || 0);
}

export const ExceedMaxPages = (props: {
  extractStatus: number;
  callback?: PaymentDialogCallback;
}) => {
  const { extractStatus, callback } = props;
  const { upgradeVip } = useUpgradeVip();
  if (checkIsExceedMaxPages(extractStatus)) {
    // 非会员，50页内的图片型文献
    if (extractStatus === -30013) {
      const handleUpgrade = () => {
        upgradeVip({
          callback,
        });
      };
      if (!callback) {
        return (
          <>非会员暂不支持图片型文献解析，升级 Plus 会员可解析最多 50 页的图片型文献。</>
        );
      }
      return (
        <span>
          <span>非会员暂不支持图片型文献解析，</span>
          <span
            className="text-primary hover:underline cursor-pointer"
            onClick={handleUpgrade}
          >升级 Plus 会员</span>
          <span>可解析最多 50 页的图片型文献。</span>
        </span>
      );
    } else {
      return (
        <>Findin 暂不支持解析超过 50 页的图片型文献。</>
      );
    }
  }
  return <></>;
}
